import type { ToBeReviewedItem } from './buildToBeReviewed';

export type NavigateToToBeReviewedPayload = {
  pickupId: string;
  /** All TBR pickup ids to select on the grid (summary card may represent many). */
  pickupIds: string[];
  alertId?: string;
  clearAllActive: boolean;
};

/**
 * Payload for NavigateToToBeReviewedPickup. Dismiss runs only after
 * Route Execution + active Pickups grid gates accept navigation.
 */
export const buildNavigateToToBeReviewedPayload = (
  item: Pick<ToBeReviewedItem, 'pickupId' | 'id' | 'relatedPickupIds'>,
  options: { clearAllActive?: boolean } = {}
): NavigateToToBeReviewedPayload => {
  const relatedPickupIds = item.relatedPickupIds;
  const pickupIds =
    relatedPickupIds && relatedPickupIds.length > 0
      ? [...relatedPickupIds]
      : [item.pickupId];

  return {
    pickupId: item.pickupId,
    pickupIds,
    alertId: item.id,
    clearAllActive: Boolean(options.clearAllActive),
  };
};

type DismissStore = {
  clearActiveToBeReviewedAlerts: () => void;
  dismissActiveToBeReviewedAlert: (alertId: string) => void;
};

/**
 * Apply TBR dismiss after navigation has been accepted by the Pickups grid.
 * Summary cards clear the whole active TBR set; per-alert dismiss remains
 * supported for future pickup notification types if needed.
 */
export const applyPickupReviewDismissAfterNavigate = (
  store: DismissStore | null | undefined,
  payload: Pick<NavigateToToBeReviewedPayload, 'clearAllActive' | 'alertId'>
): void => {
  if (!store) {
    return;
  }
  if (payload.clearAllActive) {
    store.clearActiveToBeReviewedAlerts();
    return;
  }
  if (payload.alertId) {
    store.dismissActiveToBeReviewedAlert(payload.alertId);
  }
};
